import { ScreenBase } from "@frui.ts/screens";
import OutageService, { OutageStatus } from "../../services/outageService";
import { computed } from "mobx";
import { SystemComponent } from "../../models/outage";
import { interfaces } from "inversify";
import { bound } from "@frui.ts/helpers";
import SystemComponentOutageResponse from "entities/systemComponentOutageResponse";

export default class OutagesViewModel extends ScreenBase {
  get allowToClose() {
    return this.type === SystemComponent.OTHER;
  }

  @computed
  get hasAnyActiveOutage() {
    return this.outages.some(outage => this.outageService.getOutageStatus(outage) === OutageStatus.ACTIVE);
  }

  @computed
  get outages(): SystemComponentOutageResponse[] {
    switch (this.type) {
      case SystemComponent.PAY_GATE:
        if (!this.outageService.eshopActiveOutage) {
          return this.outageService.payGateVisibleOutages;
        }
        return [];
      case SystemComponent.ISDS:
        return this.outageService.isdsVisibleOutages;
      case SystemComponent.ESHOP:
        if (this.outageService.eshopActiveOutage) {
          return [this.outageService.eshopActiveOutage];
        }
        return [];
      case SystemComponent.OTHER:
      default:
        return this.outageService.otherVisibleOutages;
    }
  }

  constructor(private outageService: OutageService, private type: SystemComponent = SystemComponent.OTHER) {
    super();
  }

  outageMessage(outage: SystemComponentOutageResponse) {
    return this.outageService.getMessage(outage);
  }

  @bound
  closeOutage(outage: SystemComponentOutageResponse) {
    this.outageService.closeOutage(outage);
  }

  static Factory({ container }: interfaces.Context) {
    return (type: SystemComponent) => {
      return new OutagesViewModel(container.get(OutageService), type);
    };
  }
}
